


















































import { Component, Vue } from "vue-property-decorator";
import { Revista, RevistasService } from "@/services/revistas.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import { required } from "@/shared/validators";
import { fileToBase64 } from "@/shared/utils/utils";

@Component({
  components: {
    Loading,
    Modal,
  },
})
export default class Manter extends Vue {
  revista: Revista | null = null;
  arquivos: File[] = [];
  valid = false;
  loading = false;
  idCatalogo = "";
  mounted() {
    this.idCatalogo = this.$route.params.idCatalogo;
  }
  rules = {
    nome: [required()],
    descricao: [required()],
    paginas: [required()],
  };

  required = (v: any) => {
    return !!v || "Campo obrigatório";
  };

  get tituloManter(): string {
    if (this.revista) {
      return this.revista.idRevista == null
        ? "Nova Revista"
        : "Alterar Revista";
    }
    return "";
  }

  async salvarRevista() {
    this.loading = true;
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      Promise.all(
        this.arquivos.map(async (arqv) => {
          const arquivoBase64 = await fileToBase64(arqv);
          return { nomeArquivo: arqv.name, arquivoBase64 };
        })
      ).then((arqs) => {
        if (this.revista) {
          RevistasService.manterRevista(this.revista, arqs).then(() => {
            this.loading = false;
            return modal.close(true);
          });
        }
      });
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async editarRevista(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.revista = await RevistasService.obterRevista(id);
    this.loading = false;

    return p;
  }

  public async novaRevista() {
    const modal = this.$refs.modal as Modal;

    this.revista = { idCatalogo: this.idCatalogo } as Revista;

    return modal.open();
  }
}
